import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let supabaseInstance: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient | null {
  if (supabaseInstance) return supabaseInstance;

  const url = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
  const key = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !key) {
    return null;
  }

  supabaseInstance = createClient(url, key);
  return supabaseInstance;
}

export function isSupabaseConnected(): boolean {
  return !!import.meta.env.VITE_PUBLIC_SUPABASE_URL && !!import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;
}